define([
  'jquery',
  'insQ',
  'jquery.style',
  'debounce',
], function($, insertionQ) {

  $.expr[':'].notonpage = $.expr.createPseudo(function(arg) {
    return function(elem) {
      if ($(elem).css("visibility") == "hidden"
        || $(elem).css("opacity") == 0
        || $(elem).css('display') == 'none'
        || $(elem).offset().top >= $(window).height()
        || $(elem).offset().right <= 0
        || $(elem).offset().left >= $(window).width()
        || $(elem).offset().left <= -$(elem).width()
        || $(elem).offset().bottom <= 0
      ) {
        return true;
      } else {
        var p = $(elem).parent();
        if (p) {
          return p.is(':notonpage');
        }
        return false;
      }
    }
  });

  $.fn.removeStyleBuffer = function(prop, side) {
    console.log('remove style buffer...');

    var that = this;

    // remove style buffer from all selected elements
    that.each(function() {
      var oldStyle = $(this).data(prop + '-buffer-' + side);
      var oldPriority = $(this).data(prop + '-buffer-' + side + '-priority');
      $(this).style(prop + '-' + side, (oldStyle == undefined) ? '' : oldStyle, (oldPriority == undefined) ? '' : oldPriority);
    });

    // remove selected elements from all groups
    $.each($.fn.styleBuffer._groups, function(key, group) {
      group.elements = group.elements.not(that);
    });

    // TODO: cleanup empty groups

    return this;
  };

  $.fn.styleBufferPage = function(elements) {
    var elements = elements || $('*');

    var pages = $('[data-sumome-stylebuffer-page]');
    var pageOffset = pages.length * $(window).height();

    if (pages.length > 0) {
      $fixed = elements.not(pages).not('body, html').filter(function() {
        if ($(this).is('[data-sumome-stylebuffer-page-fixed], #sumome-modal-mask, .sumome-dialog-popup, .sumome-dialog-popup-overlay, .sumome-blockui, .sumome-block-overlay, .sumome-sp-container'))
          return false;

        var position = $(this).css('position');

        if (position === 'fixed')
          return true;

        if (position !== 'absolute')
          return false;

        var relativeParents = $(this).parents().filter(function(idx, el) {
          return !$(el).is('body,html') && ['relative','fixed','absolute'].indexOf($(el).css('position')) >= 0;
        });

        if (!(relativeParents && relativeParents.length))
          return true;

        if ($(this).parents('[data-sumome-stylebuffer-page]').length > 0)
          return false;

        if (!$(this).parent().is('body,html'))
          return false;

        var top = $(this).position().top;

        if (top <= pageOffset && top > -2000)
          return true;

        return false;
      });

      $fixed.each(function() {
        $(this).attr('data-sumome-stylebuffer-page-fixed', true);
        var prefixes = ['', '-webkit', '-ms', '-moz', '-o'];
        for (var i = 0; i < prefixes.length; i++) {
          var prefix = prefixes[i];
          $(this).data('sumome-stylebuffer-original' + prefix + '-transform', $(this).style(prefix + (prefix ? '-' : '') + 'transform'));
          $(this).data('sumome-stylebuffer-original' + prefix + '-transform-priority', $(this).style().getPropertyPriority(prefix + (prefix ? '-' : '') + 'transform'));
          $(this).data('sumome-stylebuffer-original' + prefix + '-transition-duration', $(this).style(prefix + (prefix ? '-' : '') + 'transition-duration'));
          $(this).data('sumome-stylebuffer-original' + prefix + '-transition-duration-priority', $(this).style().getPropertyPriority(prefix + (prefix ? '-' : '') + 'transition-duration'));
          $(this).data('sumome-stylebuffer-original' + prefix + '-animation-fill-mode', $(this).style(prefix + (prefix ? '-' : '') + 'animation-fill-mode'));
          $(this).data('sumome-stylebuffer-original' + prefix + '-animation-fill-mode-priority', $(this).style().getPropertyPriority(prefix + (prefix ? '-' : '') + 'animation-fill-mode'));
          $(this).data('sumome-stylebuffer-original' + prefix + '-animation-duration', $(this).style(prefix + (prefix ? '-' : '') + 'animation-duration'));
          $(this).data('sumome-stylebuffer-original' + prefix + '-animation-duration-priority', $(this).style().getPropertyPriority(prefix + (prefix ? '-' : '') + 'animation-duration'));
        }
        for (var i = 0; i < prefixes.length; i++) {
          var prefix = prefixes[i];
          $(this).style(prefix + (prefix ? '-' : '') + 'transition-duration', '0s', 'important');
          $(this).style(prefix + (prefix ? '-' : '') + 'transform', 'scale(0,0)', 'important');
          $(this).style(prefix + (prefix ? '-' : '') + 'animation-fill-mode', 'none', 'important');
          $(this).style(prefix + (prefix ? '-' : '') + 'animation-duration', '0s', 'important');
        }
        if ($(this).is('iframe')) {
          $(this).data('sumome-stylebuffer-original-display', $(this).style('display'));
          $(this).data('sumome-stylebuffer-original-display-priority', $(this).style().getPropertyPriority('display'));
          $(this).style('display', 'none', 'important');
        }
      });
    } else {
      $('[data-sumome-stylebuffer-page-fixed]').each(function() {
        var prefixes = ['', '-webkit', '-ms', '-moz', '-o'];
        for (var i = 0; i < prefixes.length; i++) {
          var prefix = prefixes[i];
          $(this).style(prefix + (prefix ? '-' : '') + 'transform', $(this).data('sumome-stylebuffer-original' + prefix + '-transform'), $(this).data('sumome-stylebuffer-original' + prefix + '-transform-priority'));
          $(this).style(prefix + (prefix ? '-' : '') + 'animation-fill-mode', $(this).data('sumome-stylebuffer-original' + prefix + '-animation-fill-mode'), $(this).data('sumome-stylebuffer-original' + prefix + '-animation-fill-mode-priority'));
          $(this).style(prefix + (prefix ? '-' : '') + 'animation-duration', $(this).data('sumome-stylebuffer-original' + prefix + '-animation-duration'), $(this).data('sumome-stylebuffer-original' + prefix + '-animation-duration-priority'));
          setTimeout($.proxy(function() {
            $(this).style(prefix + (prefix ? '-' : '') + 'transition-duration', $(this).data('sumome-stylebuffer-original' + prefix + '-transition-duration'), $(this).data('sumome-stylebuffer-original' + prefix + '-transition-duration-priority'));
          }, this), 0);
        }
        if ($(this).is('iframe')) {
          $(this).style('display', $(this).data('sumome-stylebuffer-original-display'), $(this).data('sumome-stylebuffer-original-display-priority'));
        }
        $(this).removeAttr('data-sumome-stylebuffer-page-fixed');
      });
    }

    return pages;
  };

  $.fn.styleBufferTop = function(update) {
    if (update)
      $.fn.styleBufferTop._debounceInit(update);
    else
      $.fn.styleBufferTop._init(update);
  };

  $.fn.styleBufferTop._init = function(update) {
    console.log('style buffer top...');

    var pages = $.fn.styleBufferPage();
    var pageOffset = pages.length * $(window).height();

    if (update)
      var elements = $('[data-sumome-stylebuffer-top]');
    else
      var elements = $('[data-sumome-stylebuffer-top],[data-sumome-stylebuffer-top-stash]');

    var offset = 0;

    //console.log('style buffer top elements...', $(elements));

    // Sorts the elements by weight to ensure proper stacking
    elements.sort(function(a,b) {
      a = $(a).data('sumome-stylebuffer-top');
      b = $(b).data('sumome-stylebuffer-top');

      if (a < b)
        return -1;
      else if (a > b)
        return 1;
      else
        return 0;
    });

    // Clears the variable so we don't end up with dupes
    $.fn.styleBufferTop._groups = [];

    var $body = $('body');
    var $smartbar = $('#sumome-smartbar-popup[data-sumome-stylebuffer-top]');
    var smartbarHeight = 0;
    var smartbarShowType = false;

    $.fn.styleBufferTop.stackedElements = $(elements).not('#sumome-smartbar-popup');

    if ($smartbar && $smartbar.data('sumome-smartbar-config')) {
      smartbarHeight = $smartbar.outerHeight();
      smartbarShowType = $smartbar.data('sumome-smartbar-config').show_type;
    }

    // Loops through and calculates the total offset
    $(elements).each(function(idx, el) {
      $.fn.styleBuffer._apply($(el), 'margin', 'top', offset, true);

      $.fn.styleBufferTop._groups.push({
        elements: $(el),
        prop: 'margin',
        side: 'top',
        px: offset,
        force: true
      });

      if (typeof $(el).data('sumome-stylebuffertop-original-margin') == 'undefined')
        $(el).data('sumome-stylebuffertop-original-margin', offset);

      offset += $(el).height();
    });

    // Stashes or applies the original margin and padding
    if (typeof $body.data('sumome-stylebuffertop-original-margintop') == 'undefined') {
      if(typeof $body.data('sumome-welcomemat-original-padding-top') == 'undefined') {
        $body.data('sumome-stylebuffertop-original-paddingtop', parseInt($body.css('paddingTop')));
      } else {
        // Embedded welcome mat compatibility fixes
        $body.data('sumome-stylebuffertop-original-paddingtop', parseInt($body.data('sumome-welcomemat-original-padding-top')));
      }
      $body.data('sumome-stylebuffertop-original-margintop', parseInt($body.css('marginTop')));
      // This is new, sometimes we have padding too and we aren't doing the ol' += trick

    } else {
      $body.css('marginTop', $body.data('sumome-stylebuffertop-original-margintop'));
      $body.css('paddingTop', $body.data('sumome-stylebuffertop-original-paddingtop') + "px !important");
    }

    // Applies original positioning
    if ($.fn.styleBufferTop.oldTopElements && $.fn.styleBufferTop.oldTopElements.length) {
      $.fn.styleBufferTop.oldTopElements.each(function(idx, el) {
        if ($(el).data('sumome-stylebuffertop-original-offset')) {
          var hasInlineTop = $(el).data('sumome-stylebuffertop-has-inline').top;
          var hasInlineBottom = $(el).data('sumome-stylebuffertop-has-inline').bottom;
          var hasInlineLeft = $(el).data('sumome-stylebuffertop-has-inline').left;
          var hasInlineRight = $(el).data('sumome-stylebuffertop-has-inline').right;
          var hasInlinePosition = $(el).data('sumome-stylebuffertop-has-inline').position;

          var rightStyle = $(el).style('right');
          var rightPos = $(el).position().right;
          var originalRight = $(el).data('sumome-stylebuffertop-original-offset').right;

          var leftStyle = $(el).style('left');
          var leftPos = $(el).position().left;
          var originalLeft = $(el).data('sumome-stylebuffertop-original-offset').left;

          //$(el).style('position',$(el).data('sumome-stylebuffertop-original-position'));
          $(el).style('top',$(el).data('sumome-stylebuffertop-original-offset').top);
          $(el).style('bottom',$(el).data('sumome-stylebuffertop-original-offset').bottom);

          if(rightStyle !== originalRight && rightPos > 0) {
            $(el).style('right', originalRight);
          }

          if (parseInt(originalLeft) > -2000 && leftStyle !== originalLeft && leftPos < $(window).width()) {
            $(el).style('left', originalLeft);
          }

          // Remove styling for elements without inline styles to begin with
          if (!hasInlineTop) {
            $(el)[0].style.top = '';
          }
          if (!hasInlineRight) {
            $(el)[0].style.right = '';
          }
          if (!hasInlineLeft) {
            $(el)[0].style.left = '';
          }
          if (!hasInlineBottom) {
            $(el)[0].style.bottom = '';
          }
          if(!hasInlinePosition) {
            $(el)[0].style.position = '';
          }
        } else {
          $(el).style('top','0px');
        }
      });
    }

    if (!update) {
      if ($.fn.styleBufferTop.classFixedElements === false)
        $.fn.styleBufferTop.classFixedElements = $('.fixed').not(elements).length;

      var sumomeElements = [
        '.sumome-dialog-popup',
        '.sumome-dialog-popup-overlay',
        '.sumome-image-sharer',
        '.sumome-contactform-left-page-hidden',
        '.sumome-contactform-right-page-hidden',
      ];

      // Grabs the old top elements
      $.fn.styleBufferTop.oldTopElements = $('*').not(elements).not(pages).filter(function(idx, el) {
        var isTopEl = (['absolute','fixed'].indexOf($(el).css('position')) >= 0
          && $(el).position().top < offset
          && $(el).position().top > -2000
          && $(el).height() + $(el).position().top > 0
          && $(el).attr('id') != 'sumome-modal-mask'
          && !$(el).is(sumomeElements.join(','))
          && !$(el).parent().is('#parallax-images')
        );

        if (isTopEl && typeof $(el).data('sumome-stylebuffertop-original-position') == 'undefined') {
          $(el).data('sumome-stylebuffertop-original-position', $(el).css('position'));

          var hasInline = {
            top: $(el)[0].style.top !== '',
            left: $(el)[0].style.left !== '',
            right: $(el)[0].style.right !== '',
            bottom: $(el)[0].style.bottom !== '',
            position: $(el)[0].style.position !== '',
          };

          var originalOffset = {
            'top': $(el).css('top'),
            'left': $(el).css('left'),
            'bottom': $(el).css('bottom'),
            'right': $(el).css('right')
          };

          if (originalOffset.bottom != 'auto' && parseFloat(originalOffset.bottom) > 0)
            originalOffset.bottom = (parseFloat(originalOffset.bottom) - offset) + 'px';

          $(el).data('sumome-stylebuffertop-original-offset', originalOffset);
          $(el).data('sumome-stylebuffertop-has-inline', hasInline);
        }

        return isTopEl;
      });

      $.fn.styleBufferTop.oldTopElements = $.fn.styleBufferTop.oldTopElements.filter(function(idx, el) {
        if ($(el).css('position') == 'fixed')
          return true;

        var relativeParents = $(el).parents().filter(function(idx, el) {
          return !$(el).is('body,html') && ['relative','fixed','absolute'].indexOf($(el).css('position')) >= 0;
        });

        return (!(relativeParents && relativeParents.length));
      });

      // Grabs the bump down elements
      $.fn.styleBufferTop.bumpDownElements = $.fn.styleBufferTop.oldTopElements.filter(function(idx, el) {
        var childOfSpecialPosition = false;

        if ($(el).css('position') == 'fixed')
          return true;

        $(el).parents().each(function(idx, el) {
          if (!$(el).is('body,html')) {
            if (['relative','absolute'].indexOf($(el).css('position')) >= 0) {
              childOfSpecialPosition = true;
              return false;
            }
          }
        });

        return !childOfSpecialPosition;
      });

      // Grabs the change position elements
      $.fn.styleBufferTop.changePositionElements = $.fn.styleBufferTop.bumpDownElements.filter(function(idx, el) {
        var childOfSpecialPosition = false;

        if ($(el).css('position') == 'fixed') {
          $(el).parents().each(function(idx, el) {
            if (!$(el).is('body,html')) {
              if (['relative','absolute','fixed'].indexOf($(el).css('position')) >= 0) {
                childOfSpecialPosition = true;
                return false;
              }
            }
          });

          if (childOfSpecialPosition) {
            $(el).data('sumome-stylebuffertop-offset', {
              'top': $(el).offset().top - $(window).scrollTop(),
              'left': $(el).offset().left - $(window).scrollLeft()
            });
          }

          return childOfSpecialPosition;
        } else {
          return false;
        }
      });
    }

    // Let's do some smart smartbar specific stuff
    if (smartbarShowType == 'smart') {
      $.fn.styleBufferTop.oldTopElements.addClass('sumome-smartbar-fixedTopSmart');
      $(elements).not('#sumome-smartbar-popup').style('transition', 'margin-top .2s ease-in-out');
      $body.style('transition', 'margin-top .2s ease-in-out');
    }

    // TODO still using `smartbar-new-offset` which is used in smartbar.js
    if (smartbarShowType == 'static') {
      if ($.fn.styleBufferTop.bumpDownElements && $.fn.styleBufferTop.bumpDownElements.length) {
        $.fn.styleBufferTop.bumpDownElements.each(function(idx, el) {
          var changePosition = false;
          if ($.inArray(el, $.fn.styleBufferTop.changePositionElements) >= 0) {
            changePosition = true;
            var elementLocation = $(el).offset();
          }

          $(el).style('position','absolute');

          if (changePosition) {
            $(el).data('sumome-smartbar-new-offset', {
              'top': smartbarHeight + elementLocation.top - $(el).offset().top,
              'left': elementLocation.left - $(el).offset().left
            });
            $(el).style('top', $(el).data('sumome-smartbar-new-offset').top + 'px');

            // Set new left offset only if it's different from the original.
            if($(el).data('sumome-smartbar-new-offset').left !== parseInt($(el).data('sumome-stylebuffertop-original-offset').left) && parseInt($(el).data('sumome-stylebuffertop-original-offset').left) > $(window).width()) {
              $(el).style('left', $(el).data('sumome-smartbar-new-offset').left + 'px');
            }
          } else {
            $(el).style('top', offset + 'px');
          }

          $(el).data('sumome-stylebuffertop-original-top', offset);
        });

        $.fn.styleBufferTop.oldTopElements.each(function(idx, el) {
          $(el).css('position', $(el).data('sumome-stylebuffertop-original-position'));
        });
      }

      function staticSmartBarScroll() {
        var smartbarPopup = document.getElementById('sumome-smartbar-popup');

        if (smartbarPopup) {
          var smartbarRect = smartbarPopup.getBoundingClientRect();
          var smartbarOffset = smartbarRect.height;

          if (smartbarRect.bottom > 0)
            smartbarOffset = smartbarRect.height - smartbarRect.bottom;

          $.fn.styleBufferTop.stackedElements.each(function(idx, el) {
            $(el).css('marginTop', $(el).data('sumome-stylebuffertop-original-margin') - smartbarOffset);
          });

          $.fn.styleBufferTop.oldTopElements.each(function(idx, el) {
            $(el).css('position', $(el).data('sumome-stylebuffertop-original-position'));
            $(el).css('top', $(el).data('sumome-stylebuffertop-original-top') - smartbarOffset);
          });
        }
      }

      $(window).scroll(staticSmartBarScroll);
      staticSmartBarScroll();
    } else {
      if ($.fn.styleBufferTop.oldTopElements && $.fn.styleBufferTop.oldTopElements.length) {
        $.fn.styleBufferTop.oldTopElements.each(function(idx, el) {
          if ($(el).data('sumome-stylebuffertop-original-offset'))
            if ($(el).data('sumome-stylebuffertop-original-offset').top == 'auto') {
              console.log('got auto top... setting bottom instead');
              console.log($(el));
              /*
              console.log(parseFloat($(el).data('sumome-stylebuffertop-original-offset').bottom));
              console.log(offset);
              console.log(parseFloat($(el).data('sumome-stylebuffertop-original-offset').bottom) - offset);
              var px = (parseFloat($(el).data('sumome-stylebuffertop-original-offset').bottom) - offset) + 'px';
              console.log(px);
              $(el).style('bottom', px);
              console.log($(el).css('bottom'));
              */
            } else {
              $(el).style('top', offset + parseFloat($(el).data('sumome-stylebuffertop-original-offset').top) + 'px');
            }
        });
      }

      // Tries to catch elements that have a fixed class added when scrolling
      if (smartbarShowType == 'fixed') {
        $(window).scroll(function() {
          var threshold = 60;
          var scrollTop = $(window).scrollTop();

          if ($.fn.styleBufferTop.classFixedElements !== $.fn.styleBufferTop.classFixedElementsScroll) {
            if (scrollTop >= threshold && $.fn.styleBufferTop.classFixedElementsScroll === false) {
              $.fn.styleBufferTop.classFixedElementsScroll = $('.fixed').not(elements).length;
            } else {
              if (scrollTop >= threshold && !$.fn.styleBufferTop.checkScrollDown) {
                $.fn.styleBufferTop.checkScrollDown = true;
                $.fn.styleBufferTop.checkScrollUp = false;
                $('body').styleBufferTop();
              } else if (scrollTop < threshold && !$.fn.styleBufferTop.checkScrollUp) {
                $.fn.styleBufferTop.checkScrollDown = false;
                $.fn.styleBufferTop.checkScrollUp = true;
                $('body').styleBufferTop();
              }
            }
          }
        });
      }
    }

    // Take the stashed items that may be hidden into consideration for the offset
    var $smartbar = $('#sumome-smartbar-popup');

    if ($smartbar && $smartbar.data('sumome-smartbar-config') && $smartbar.data('sumome-smartbar-config').show_type == 'smart') {
      offset = 0;
      $('[data-sumome-stylebuffer-top],[data-sumome-stylebuffer-top-stash]').each(function() {
        offset += $(this).outerHeight();
      });
    }

    $.fn.styleBufferTop.totalOffset = offset;
    offset += $body.data('sumome-stylebuffertop-original-paddingtop') + $body.data('sumome-stylebuffertop-original-margintop');

    // Throws this (body) into the group too
    if (offset + pageOffset !== 0) {
      $.fn.styleBuffer._apply($body, 'padding', 'top', offset + pageOffset, true, 'important');
      $.fn.styleBuffer._apply($body, 'margin', 'top', 0, true, 'important');

      $.fn.styleBufferTop._groups.push({
        elements: $body,
        prop: 'padding',
        side: 'top',
        px: offset + pageOffset,
        force: true,
        priority: 'important'
      });
      $.fn.styleBufferTop._groups.push({
        elements: $body,
        prop: 'margin',
        side: 'top',
        px: 0,
        force: true,
        priority: 'important'
      });
    } else {
      $body.removeStyleBuffer('padding', 'top');
      $body.removeStyleBuffer('margin', 'top');
    }

    // Looks for that sibling selector bugfix that borks padding
    // http://codepen.io/simeydotme/blog/hot-pockets
    if ($body.css('-webkit-animation-name') == 'bugfix' || $body.css('-webkit-animation-name') == 'androidbugfix') {
      if ($('[data-sumome-stylebuffertop-bugfix]').length)
        $('[data-sumome-stylebuffertop-bugfix]').remove();

      $body.append('<style data-sumome-stylebuffertop-bugfix>@-webkit-keyframes sumome-bugfix { from { fill: 0; } to { fill: 0; } }</style>');
      $body.css('-webkit-animation', 'sumome-bugfix infinite 1s');
    }

    if (typeof $body.data('sumome-stylebuffertop-original-bgposition') == 'undefined') {
      $body.data('sumome-stylebuffertop-original-bgposition', $body.css('backgroundPosition'));
      $body.data('sumome-stylebuffertop-original-bgpositiony', $body.css('backgroundPositionY'));
      $body.data('sumome-stylebuffertop-original-bgrepeat', $body.css('backgroundRepeat'));
    }

    // If the background is fixed top and no repeat, let's assume it's part of the layout and push it down
    if (($body.data('sumome-stylebuffertop-original-bgposition') == '50% 0%'
      && $body.data('sumome-stylebuffertop-original-bgrepeat') == 'no-repeat')
      || ($body.data('sumome-stylebuffertop-original-bgposition') == '0% 0%'
      && $body.data('sumome-stylebuffertop-original-bgrepeat') == 'repeat-x')
    ) {
      $body.css('backgroundPositionY', offset);
    }

    if (/^50% [0-9]+px, 0% [0-9]+px$/.test($body.data('sumome-stylebuffertop-original-bgposition'))
      && /^no-repeat/.test($body.data('sumome-stylebuffertop-original-bgrepeat'))
    ) {
      var originalBgPosY = $body.data('sumome-stylebuffertop-original-bgpositiony').split(', ');
      $body.css('backgroundPositionY', (parseInt(originalBgPosY[0]) + offset) + 'px, ' + (parseInt(originalBgPosY[1]) + offset) + 'px');
    }

    return this;
  };

  $.fn.styleBufferTop._debounceInit = $.debounce(150, true, function(update) {
    $.fn.styleBufferTop._init(update);
  });

  $.fn.styleBufferBottom = function(update) {
    if (update)
      $.fn.styleBufferBottom._debounceInit(update);
    else
      $.fn.styleBufferBottom._init(update);
  };

  $.fn.styleBufferBottom._init = function(update) {
    console.log('style buffer bottom...');

    var pages = $('[data-sumome-stylebuffer-page]');

    if (update)
      var elements = $('[data-sumome-stylebuffer-bottom]');
    else
      var elements = $('[data-sumome-stylebuffer-bottom],[data-sumome-stylebuffer-bottom-stash]');

    var offset = 0;

    //console.log('style buffer bottom elements...', $(elements));

    // Sorts the elements by weight to ensure proper stacking
    elements.sort(function(a,b) {
      a = $(a).data('sumome-stylebuffer-bottom');
      b = $(b).data('sumome-stylebuffer-bottom');

      if (a < b)
        return -1;
      else if (a > b)
        return 1;
      else
        return 0;
    });

    // Clears the variable so we don't end up with dupes
    $.fn.styleBufferBottom._groups = [];

    var $body = $('body');
    var $smartbar = $('#sumome-smartbar-popup[data-sumome-stylebuffer-bottom]');
    var smartbarHeight = 0;
    var smartbarShowType = false;

    $.fn.styleBufferBottom.stackedElements = $(elements).not('#sumome-smartbar-popup');

    if ($smartbar && $smartbar.data('sumome-smartbar-config')) {
      smartbarHeight = $smartbar.outerHeight();
      smartbarShowType = $smartbar.data('sumome-smartbar-config').show_type;
    }

    // Loops through and calculates the total offset
    $(elements).each(function(idx, el) {
      if ($(el).data('sumome-stylebufferbottom-offsety'))
        offset += $(el).data('sumome-stylebufferbottom-offsety');

      $.fn.styleBuffer._apply($(el), 'top', 'top', 'auto', true);
      $.fn.styleBuffer._apply($(el), 'bottom', 'bottom', offset, true);

      $.fn.styleBufferBottom._groups.push({
        elements: $(el),
        prop: 'top',
        side: 'top',
        px: 'auto',
        force: true
      });
      $.fn.styleBufferBottom._groups.push({
        elements: $(el),
        prop: 'bottom',
        side: 'bottom',
        px: offset,
        force: true
      });

      if (typeof $(el).data('sumome-stylebufferbottom-original-bottom') == 'undefined')
        $(el).data('sumome-stylebufferbottom-original-bottom', offset);

      offset += $(el).height();
    });

    // Stashes or applies the original margin and padding
    if (typeof $body.data('sumome-stylebufferbottom-original-marginbottom') == 'undefined') {
      $body.data('sumome-stylebufferbottom-original-marginbottom', parseInt($body.css('marginBottom')));
      // This is new, sometimes we have padding too and we aren't doing the ol' += trick
      $body.data('sumome-stylebufferbottom-original-paddingbottom', parseInt($body.css('paddingBottom')));
    } else {
      $body.css('marginBottom', $body.data('sumome-stylebufferbottom-original-marginbottom'));
      $body.css('paddingBottom', $body.data('sumome-stylebufferbottom-original-paddingbottom'));
    }

    // Applies original positioning
    if ($.fn.styleBufferBottom.oldBottomElements && $.fn.styleBufferBottom.oldBottomElements.length) {
      $.fn.styleBufferBottom.oldBottomElements.each(function(idx, el) {
        if ($(el).data('sumome-stylebufferbottom-original-offset')) {
          var hasInlineTop = $(el).data('sumome-stylebufferbottom-has-inline').top;
          var hasInlineBottom = $(el).data('sumome-stylebufferbottom-has-inline').bottom;
          var hasInlineLeft = $(el).data('sumome-stylebufferbottom-has-inline').left;
          var hasInlineRight = $(el).data('sumome-stylebufferbottom-has-inline').right;
          var hasInlinePosition = $(el).data('sumome-stylebufferbottom-has-inline').position;

          $(el).style('position',$(el).data('sumome-stylebufferbottom-original-position'));
          $(el).style('top',$(el).data('sumome-stylebufferbottom-original-offset').top);
          $(el).style('bottom',$(el).data('sumome-stylebufferbottom-original-offset').bottom);
          $(el).style('left', $(el).data('sumome-stylebufferbottom-original-offset').left);
          $(el).style('right', $(el).data('sumome-stylebufferbottom-original-offset').right);

          // Remove styling for elements without inline styles to begin with
          if(!hasInlineTop) {
            $(el)[0].style.top = '';
          }
          if(!hasInlineRight) {
            $(el)[0].style.right = '';
          }
          if(!hasInlineLeft) {
            $(el)[0].style.left = '';
          }
          if(!hasInlineBottom) {
            $(el)[0].style.bottom = '';
          }
          if(!hasInlinePosition) {
            $(el)[0].style.position = '';
          }
        } else {
          $(el).style('bottom','0px');
        }
      });
    }

    if (!update) {
      var sumomeElements = [
        '#sumome-modal-mask',
        '.sumome-dialog-popup',
        '.sumome-dialog-popup-overlay',
      ];

      var bottomTabElements = [
        'sumome-react-form-tab-bottom-left',
        'sumome-react-form-tab-bottom-center',
        'sumome-react-form-tab-bottom-right',
      ];

      // Grabs the old top elements
      $.fn.styleBufferBottom.oldBottomElements = $('*').not(elements).not(pages).filter(function(idx, el) {
        var isBottomEl = (
          ['absolute','fixed'].indexOf($(el).css('position')) >= 0
          && parseInt($(el).css('bottom')) < offset
          && !$(el).is(sumomeElements.join(','))
        );

        if ($(el).is(bottomTabElements.join(','))) isBottomEl = true;

        if (isBottomEl && typeof $(el).data('sumome-stylebufferbottom-original-position') == 'undefined') {
          $(el).data('sumome-stylebufferbottom-original-position', $(el).css('position'));
          $(el).data('sumome-stylebufferbottom-original-offset', {
            'top': $(el).css('top'),
            'left': $(el).css('left'),
            'bottom': $(el).css('bottom'),
            'right': $(el).css('right')
          });

          $(el).data('sumome-stylebufferbottom-has-inline', {
            top: $(el)[0].style.top !== '',
            left: $(el)[0].style.left !== '',
            right: $(el)[0].style.right !== '',
            bottom: $(el)[0].style.bottom !== '',
            position: $(el)[0].style.position !== '',
          });
        }

        return isBottomEl;
      });

      var windowHeight = $(window).height();

      $.fn.styleBufferBottom.oldBottomElements = $.fn.styleBufferBottom.oldBottomElements.filter(function(idx, el) {
        if ($(el).is(bottomTabElements.join(','))) return true;

        // Don't shift items that are the same size as the view port, they are probably nav menus
        if ($(el).height() >= windowHeight)
          return false;

        if ($(el).css('position') === 'fixed')
          return !($(el).is(':notonpage'));

        if ($(el).css('position') === 'absolute' && ($(el).is(':notonpage'))) {
          return false;
        }

        var relativeParents = $(el).parents().filter(function(idx, el) {
          return !$(el).is('body,html') && ['relative','fixed','absolute'].indexOf($(el).css('position')) >= 0;
        });

        return (!(relativeParents && relativeParents.length));
      });
    }

    // Let's do some smart smartbar specific stuff
    // TODO
    if (smartbarShowType == 'smart') {
      //$.fn.styleBufferBottom.oldTopElements.addClass('sumome-smartbar-fixedTopSmart');
      $(elements).not('#sumome-smartbar-popup').style('transition', 'bottom .2s ease-in-out');
      //$body.style('transition', 'margin-top .2s ease-in-out');
    }

    if ($.fn.styleBufferBottom.oldBottomElements && $.fn.styleBufferBottom.oldBottomElements.length) {
      $.fn.styleBufferBottom.oldBottomElements.each(function(idx, el) {
        $(el).style('bottom', offset + parseFloat($(el).data('sumome-stylebufferbottom-original-offset').bottom) + 'px');
        offset += (offset === 0 || $(el).style('position') === 'fixed') ? 0 : $(el).height();
      });
    }

    $.fn.styleBufferBottom.totalOffset = offset;
    offset += $body.data('sumome-stylebufferbottom-original-paddingbottom') + $body.data('sumome-stylebufferbottom-original-marginbottom');

    // Adds a shim to push stuff up
    if (!$('.sumome-stylebufferbottom-shim').length)
      $('<div class="sumome-stylebufferbottom-shim" />').appendTo($body);

    var shim = $('.sumome-stylebufferbottom-shim');
    shim.height(offset);

    return this;
  };

  $.fn.styleBufferBottom._debounceInit = $.debounce(150, true, function(update) {
    $.fn.styleBufferBottom._init(update);
  });

  $.fn.styleBuffer = function(prop, side, px) {
    console.log('style buffer...');

    if (this.length < 1)
      return this;

    // keep track of this group so we can re-apply later on load and resize events
    $.fn.styleBuffer._groups.push({
      elements: this,
      prop: prop,
      side: side,
      px: px,
      force: false,
    });

    // match each element's height to the tallest element in the selection
    $.fn.styleBuffer._apply(this, prop, side, px, false);

    return this;
  };

  $.fn.styleBuffer._apply = function(elements, prop, side, px, force, priority) {
    //console.log('style buffer apply...');

    var $elements = $(elements);

    $elements.each(function() {
      var $that = $(this);

      // Allows us to do things like set the bottom or top instead of just margin or padding
      if (prop == side) {
        $that.style(prop, px + (px != 'auto' ? 'px' : ''), (priority == undefined) ? '' : priority);
      } else {
        var oldStyle = $that.data(prop + '-buffer-' + side);
        var oldPriority = $that.data(prop + '-buffer-' + side + '-priority');
        if (oldStyle == undefined) {
          oldStyle = $that.style(prop + '-' + side);
          oldPriority = $that.style().getPropertyPriority(prop + '-' + side);
          $that.data(prop + '-buffer-' + side, (oldStyle == undefined) ? '' : oldStyle);
          $that.data(prop + '-buffer-' + side + '-priority', (oldPriority == undefined) ? '' : oldPriority);
        } else {
          $(this).style(prop + '-' + side, oldStyle, (oldPriority == undefined) ? '' : oldPriority);
        }

        if (force) {
          $that.style(prop + '-' + side, px + 'px', (priority == undefined) ? '' : priority);
        } else {
          var pad = _parse($that.css(prop + '-' + side));
          $that.style(prop + '-' + side, Math.max(pad, px) + 'px', (priority == undefined) ? '' : priority);
        }
      }
    });

    return this;
  };

  $.fn.styleBuffer.smartHide = function(smartbarHeight, positionTop) {
    if (!$.fn.styleBuffer.firedSmartHide) {
      console.log('style buffer top smart hide...');

      $.fn.styleBuffer.firedSmartHide = true;
      $.fn.styleBuffer.firedSmartShow = false;

      if (positionTop) {
        var $styleBuffer = $.fn.styleBufferTop;
        var $oldElements = $styleBuffer.oldTopElements;
        var originalMargin = 'sumome-stylebuffertop-original-margin';
        var originalOffset = 'sumome-stylebuffertop-original-offset';
        var originalPosition = 'sumome-stylebuffertop-original-position';
        var oldElCssProperty = 'top';
        var stackedCssProperty = 'marginTop';
      } else {
        var $styleBuffer = $.fn.styleBufferBottom;
        var $oldElements = $styleBuffer.oldBottomElements;
        var originalMargin = 'sumome-stylebufferbottom-original-bottom';
        var originalOffset = 'sumome-stylebufferbottom-original-offset';
        var originalPosition = 'sumome-stylebufferbottom-original-position';
        var oldElCssProperty = 'bottom';
        var stackedCssProperty = 'bottom';

        if ($('.sumome-stylebufferbottom-shim').length)
          $('.sumome-stylebufferbottom-shim').height('-=' + smartbarHeight);
      }

      if ($oldElements && $oldElements.length) {
        $oldElements.each(function(idx, el) {
          if ($(el).data(originalOffset)) {
            if ($(el).data(originalPosition) == 'fixed')
              var newOffset = $styleBuffer.totalOffset - smartbarHeight;
            else
              var newOffset = smartbarHeight + parseFloat($(el).data(originalOffset).top);

            $(el).style(oldElCssProperty, newOffset + 'px');
          } else {
            $(el).style(oldElCssProperty, '0px');
          }
        });
      }

      if ($styleBuffer.stackedElements && $styleBuffer.stackedElements.length) {
        $styleBuffer.stackedElements.each(function(idx, el) {
          $(el).css(stackedCssProperty, $(el).data(originalMargin) - smartbarHeight);
        });
      }
    }
  };

  $.fn.styleBuffer.smartShow = function(smartbarHeight, positionTop) {
    if (!$.fn.styleBuffer.firedSmartShow) {
      console.log('style buffer top smart show...');

      $.fn.styleBuffer.firedSmartHide = false;
      $.fn.styleBuffer.firedSmartShow = true;

      if (positionTop) {
        var $styleBuffer = $.fn.styleBufferTop;
        var $oldElements = $styleBuffer.oldTopElements;
        var originalMargin = 'sumome-stylebuffertop-original-margin';
        var originalOffset = 'sumome-stylebuffertop-original-offset';
        var oldElCssProperty = 'top';
        var stackedCssProperty = 'marginTop';
      } else {
        var $styleBuffer = $.fn.styleBufferBottom;
        var $oldElements = $styleBuffer.oldBottomElements;
        var originalMargin = 'sumome-stylebufferbottom-original-bottom';
        var originalOffset = 'sumome-stylebufferbottom-original-offset';
        var oldElCssProperty = 'bottom';
        var stackedCssProperty = 'bottom';

        if ($('.sumome-stylebufferbottom-shim').length)
          $('.sumome-stylebufferbottom-shim').height('+=' + smartbarHeight);
      }

      if ($oldElements && $oldElements.length) {
        $oldElements.each(function(idx, el) {
          if ($(el).data(originalOffset))
            $(el).style(oldElCssProperty, $styleBuffer.totalOffset + 'px');
          else
            $(el).style(oldElCssProperty, smartbarHeight + 'px');
        });
      }

      if ($styleBuffer.stackedElements && $styleBuffer.stackedElements.length) {
        $styleBuffer.stackedElements.each(function(idx, el) {
          $(el).css(stackedCssProperty, $(el).data(originalMargin));
        });
      }
    }
  };

  /*
  *  _update function will re-apply styleBuffer to all groups with the correct options
  */

  $.fn.styleBuffer._groups = [];
  $.fn.styleBuffer._throttle = 80;

  $.fn.styleBuffer.firedSmartHide = false;
  $.fn.styleBuffer.firedSmartShow = false;

  $.fn.styleBufferTop._groups = [];
  $.fn.styleBufferTop.stackedElements = null;
  $.fn.styleBufferTop.oldTopElements = null;
  $.fn.styleBufferTop.bumpDownElements = null;
  $.fn.styleBufferTop.changePositionElements = null;
  $.fn.styleBufferTop.totalOffset = 0;
  $.fn.styleBufferTop.checkedScrollDown = false;
  $.fn.styleBufferTop.classFixedElements = false;
  $.fn.styleBufferTop.classFixedElementsScroll = false;
  $.fn.styleBufferTop.checkScrollDown = false;
  $.fn.styleBufferTop.checkScrollUp = true;

  $.fn.styleBufferBottom._groups = [];
  $.fn.styleBufferBottom.stackedElements = null;
  $.fn.styleBufferBottom.oldBottomElements = null;
  $.fn.styleBufferBottom.totalOffset = 0;

  var previousResizeWidth = -1;

  $.fn.styleBuffer._update = $.debounce(150, true, function(event) {
    console.log('style buffer update...');

    // prevent update if fired from a resize event
    // where the viewport width hasn't actually changed
    // fixes an event looping bug in IE8
    if (event && event.type === 'resize') {
      var windowWidth = $(window).width();
      if (windowWidth === previousResizeWidth)
        return;
      previousResizeWidth = windowWidth;
    }

    $.each($.fn.styleBuffer._groups, function() {
      $.fn.styleBuffer._apply(this.elements, this.prop, this.side, this.px, this.force, this.priority);
    });

    if ($.fn.styleBufferTop._groups.length) {
      // Refreshes the elements
      $('body').styleBufferTop(true);

      $.each($.fn.styleBufferTop._groups, function() {
        $.fn.styleBuffer._apply(this.elements, this.prop, this.side, this.px, this.force, this.priority);
      });
    }

    if ($.fn.styleBufferBottom._groups.length) {
      // Refreshes the elements
      $('body').styleBufferBottom(true);

      $.each($.fn.styleBufferBottom._groups, function() {
        $.fn.styleBuffer._apply(this.elements, this.prop, this.side, this.px, this.force, this.priority);
      });
    }

    // Trigger welcome mat resize to fix any possible issues with embedded welcome mat
    $(window).trigger('resize.sumome-welcomemat');
  });

  /*
  *  bind events
  */

  // update heights on load and resize events
  $(window).bind('load resize orientationchange', function(e) {
    if (e && e.type == 'resize' && e.target != window) {
      return;
    }
    console.log('style buffer load resize orientationchange...');
    $.fn.styleBuffer._update(e);
  });

  insertionQ.config({
    strictlyNew: false
  });

  insertionQ('#menufication-top').every($.proxy(function(el) {
    $('body').styleBufferTop();
  }, this));

  var _parse = function(value) {
    // parse value and convert NaN to 0
    return parseFloat(value) || 0;
  };
});
